module.exports = __webpack_public_path__ + "static/media/validate_arrow_disabled.4c66f3e0.svg";